import { Divider, MaxWidth, PreIcon } from '@advanza/ui'
import LimitReachedOverview from 'components/limitReached/LimitReachedOverview'
import ProvidersFilter from 'components/providers/ProvidersFilter'
import ProvidersList from 'components/providers/ProvidersList'
import Restricted from 'components/Restricted'
import Page from 'components/ui/Page'
import { useAppSelector } from 'hooks/hooks'
import queryString from 'query-string'
import React from 'react'
import style from './LimitReachedPage.module.css'

const LimitReachedPage = () => {
    const filterId = 'limitReached'
    const filter = useAppSelector((state) => state.providers.filters)[filterId]
    return (
        <Page title="Limits">
            <Divider xl />
            <MaxWidth maxWidth={1400}>
                <div className={style.header}>
                    <h1>
                        <PreIcon icon="production_quantity_limits">Limits reached overview</PreIcon>
                    </h1>
                    <Restricted location="export" checkWrite={false}>
                        <PreIcon name="exit_to_app">
                            <a
                                target="_blank"
                                href={`${window.location.protocol}//${
                                    window.location.hostname
                                }/api/office/providers/export/?${queryString.stringify({
                                    ...filter,
                                    noLimit: true,
                                })}`}>
                                Export sheet
                            </a>
                        </PreIcon>
                    </Restricted>
                </div>
                <Divider m />
                <ProvidersFilter
                    filterId={filterId}
                    defaultOptions={{
                        includeLimitReached: 1,
                        flags: ['signed'],
                        order: 'limitsReached DESC',
                    }}
                />
                <Divider l />
                <div className={style.row}>
                    <div>
                        <h3>Week overview</h3>
                        <Divider />
                        <LimitReachedOverview filterId={filterId} />
                    </div>
                    <div>
                        <h3>Providers</h3>
                        <Divider />
                        <ProvidersList
                            showCols={[
                                'status',
                                'ActiveStatus',
                                'service',
                                'name',
                                'weekLimit',
                                'limitsReached',
                            ]}
                            filterId="limitReached"
                            includeLimitReached
                        />
                    </div>
                </div>
            </MaxWidth>
            <Divider xl />
        </Page>
    )
}

export default LimitReachedPage
